import {
  Component,
  Input,
  OnChanges,
  OnInit,
  signal,
  ViewChild,
  ViewEncapsulation,
  WritableSignal,
} from '@angular/core';
import { BlockUlItem } from '@shared/models/step.model';
import { ButtonPadding, ButtonVariant } from '@app/components/button/button.component';
import { PlIcon } from '@app/icon-library/icons';
import { MatExpansionPanel } from '@angular/material/expansion';
import { I18nService } from '@app/i18n';
import { ComponentChanges } from '@app/utils/simpleChangesType';

@Component({
  selector: 'pl-ul',
  templateUrl: './pl-ul.component.html',
  styleUrls: ['pl-ul.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PlUlComponent implements OnInit, OnChanges {
  @Input() public showMoreButtonAtStart: boolean = false;
  @Input() public minItemsDisplayed: number = 0;
  @Input({ required: true }) public label!: string;

  @Input() public items: BlockUlItem[] = [];

  public itemsFiltered: WritableSignal<BlockUlItem[]> = signal([]);

  public buttonLabel: WritableSignal<string> = signal('');

  public isPanelOpen: boolean = false;

  public readonly ButtonVariant: typeof ButtonVariant = ButtonVariant;
  public readonly PlIcon: typeof PlIcon = PlIcon;
  public readonly ButtonPadding: typeof ButtonPadding = ButtonPadding;

  @ViewChild(MatExpansionPanel) public matExpansionPanel!: MatExpansionPanel;

  constructor(private i18nService: I18nService) {}

  public ngOnChanges(changes: ComponentChanges<PlUlComponent>): void {
    if (changes.items) {
      this.itemsFiltered.set(
        changes.items.currentValue.filter((item: BlockUlItem): boolean => {
          return item && (!!item.label || !!item.sub_label || !!item.takeaways);
        }),
      );
    }
  }

  public ngOnInit(): void {
    this.isPanelOpen = !this.showMoreButtonAtStart;
    this.computeButtonLabel(!this.showMoreButtonAtStart, this.minItemsDisplayed);
  }

  public onPanelToggle(): void {
    this.computeButtonLabel(this.isPanelOpen, this.minItemsDisplayed);
  }

  public toggleExpansionPanel(): void {
    this.matExpansionPanel.toggle();
  }

  private computeButtonLabel(isPanelOpen: boolean, minItemsDisplayed: number): void {
    let translationString: string = '';
    if (isPanelOpen) {
      translationString = minItemsDisplayed === 0 ? 'blocks.ul.hide' : 'blocks.ul.show_less';
    } else {
      translationString = minItemsDisplayed === 0 ? 'blocks.ul.show' : 'blocks.ul.show_more';
    }

    this.buttonLabel.set(this.i18nService.translate(translationString));
  }
}
